import React from 'react';
import { CartSummaryDetailBannerContainer } from './style';
import CurrencyFormat from '../../utils/currencyFormat';

interface CartSummaryDetailBannerProps {
  color: string;
  totalAmount: number;
  showDetailOnMobile: boolean;
  handleShowDetailOnMobile: () => void;
}

const CartSummaryDetailBanner: React.FC<CartSummaryDetailBannerProps> = ({
  color,
  totalAmount,
  showDetailOnMobile,
  handleShowDetailOnMobile,
}) => (
  <CartSummaryDetailBannerContainer className="summary-detail-banner__display-modal-container"
   $open={showDetailOnMobile}
   onClick={handleShowDetailOnMobile}>
      <svg
        id="cart-summary-banner-cart-icon"
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <rect width="30" height="30" rx="6" fill={color} />
        <path
          d="M12.3328 18.5392H12.3335C12.3341 18.5392 12.3347 18.5391 12.3352 18.5391H20.3027C20.4989 18.5391 20.6713 18.4089 20.7253 18.2203L22.4831 12.068C22.5209 11.9354 22.4944 11.7928 22.4114 11.6827C22.3283 11.5726 22.1984 11.5078 22.0605 11.5078H11.3194L11.0052 10.0941C10.9605 9.89305 10.7822 9.75 10.5762 9.75H7.93945C7.69672 9.75 7.5 9.94672 7.5 10.1895C7.5 10.4322 7.69672 10.6289 7.93945 10.6289H10.2237C10.2793 10.8794 11.727 17.3941 11.8103 17.7689C11.3433 17.9719 11.0156 18.4376 11.0156 18.9785C11.0156 19.7054 11.6071 20.2969 12.334 20.2969H20.3027C20.5455 20.2969 20.7422 20.1002 20.7422 19.8574C20.7422 19.6147 20.5455 19.418 20.3027 19.418H12.334C12.0917 19.418 11.8945 19.2208 11.8945 18.9785C11.8945 18.7366 12.091 18.5397 12.3328 18.5392ZM21.4779 12.3867L19.9712 17.6602H12.6865L11.5146 12.3867H21.4779Z"
          fill="white"
        />
        <path
          d="M11.8945 21.6152C11.8945 22.3422 12.486 22.9336 13.2129 22.9336C13.9398 22.9336 14.5312 22.3422 14.5312 21.6152C14.5312 20.8883 13.9398 20.2969 13.2129 20.2969C12.486 20.2969 11.8945 20.8883 11.8945 21.6152ZM13.2129 21.1758C13.4552 21.1758 13.6523 21.373 13.6523 21.6152C13.6523 21.8575 13.4552 22.0547 13.2129 22.0547C12.9706 22.0547 12.7734 21.8575 12.7734 21.6152C12.7734 21.373 12.9706 21.1758 13.2129 21.1758Z"
          fill="white"
        />
        <path
          d="M18.1055 21.6152C18.1055 22.3422 18.6969 22.9336 19.4238 22.9336C20.1508 22.9336 20.7422 22.3422 20.7422 21.6152C20.7422 20.8883 20.1508 20.2969 19.4238 20.2969C18.6969 20.2969 18.1055 20.8883 18.1055 21.6152ZM19.4238 21.1758C19.6661 21.1758 19.8633 21.373 19.8633 21.6152C19.8633 21.8575 19.6661 22.0547 19.4238 22.0547C19.1816 22.0547 18.9844 21.8575 18.9844 21.6152C18.9844 21.373 19.1816 21.1758 19.4238 21.1758Z"
          fill="white"
        />
      </svg>

      <h3 style={{ color: color }}>{showDetailOnMobile ? 'Ocultar' : 'Mostrar'} resumen del pedido</h3>

      {showDetailOnMobile ? 
      //Chevron Up
      <svg id='cart-summary-banner-chevron-up' xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill='none'>
      <path d="M1.07274 4.89717L3.50323 2.44344L5.93372 4.89717C6.17802 5.14381 6.57266 5.14381 6.81697 4.89717C7.06127 4.65054 7.06127 4.25212 6.81697 4.00548L3.94172 1.10274C3.69742 0.856097 3.30278 0.856097 3.05847 1.10274L0.183226 4.00548C-0.0610755 4.25212 -0.0610755 4.65054 0.183226 4.89717C0.427528 5.13749 0.828434 5.14381 1.07274 4.89717Z" fill={color}/>
    </svg>

      :
      //Chevron Down
      <svg
      id="cart-summary-banner-chevron-down"
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="6"
      viewBox="0 0 7 6"
      fill="none"
    >
      <path
        d="M5.92751 1.10283L3.49702 3.55656L1.06652 1.10283C0.822223 0.856187 0.42758 0.856187 0.183279 1.10283C-0.0610237 1.34946 -0.0610237 1.74788 0.183279 1.99452L3.05853 4.89726C3.30283 5.1439 3.69747 5.1439 3.94177 4.89726L6.81702 1.99452C7.06132 1.74788 7.06132 1.34946 6.81702 1.10283C6.57272 0.862511 6.17181 0.856187 5.92751 1.10283Z"
        fill={color}
      />
    </svg>
    }

 

    <CurrencyFormat
      className="cart-summary-banner__amount"
      amount={Math.abs(totalAmount)}
    />
  </CartSummaryDetailBannerContainer>
);

export default CartSummaryDetailBanner;
